import { scheduleAutoSwitchToast } from '@apps/web/lib/auto_switch_toast';
import { modeStore } from '@apps/web/lib/mode_store';
import { type Mode } from '@libraries/typescript/api_client';

/** Announce a context switch only after every guarded change proceeds. */
export function switchContextWithToast({
    current,
    next,
    organizationName,
    resourceLabel,
    setOrganizationId,
}: {
    readonly current: {
        readonly organizationId: string | null;
        readonly mode: Mode | undefined;
    };
    readonly next: { readonly organizationId: string; readonly mode: Mode };
    readonly organizationName?: string | null;
    readonly resourceLabel: string;
    readonly setOrganizationId: (id: string, onChanged?: () => void) => void;
}) {
    const organizationChanged = next.organizationId !== current.organizationId;
    const modeChanged = next.mode !== current.mode;
    let remaining = Number(organizationChanged) + Number(modeChanged);
    const onChanged = () => {
        remaining -= 1;
        if (remaining === 0) {
            scheduleAutoSwitchToast({
                organizationName: organizationChanged
                    ? (organizationName ?? null)
                    : null,
                mode: modeChanged ? next.mode : null,
                resourceLabel,
            });
        }
    };
    if (organizationChanged) {
        setOrganizationId(next.organizationId, onChanged);
    }
    if (modeChanged) {
        modeStore.setMode(next.mode, onChanged);
    }
}
